module.exports = __webpack_public_path__ + "img/th_Rip_Rap.de1468f5.jpg";